module.exports = __webpack_public_path__ + "img/wheel-1.392c57c9.png";